import React from 'react';
import { Award, BookOpen, GraduationCap } from 'lucide-react';
import { profileData } from '../../data/profileData';
import { Button, Card, Icon } from '../ui';

const UT_AUSTIN_CERTIFICATE_URL = 'https://la.utexas.edu/texasexeced/digitalVerification.html?key=gmipbfeh';

/** The UT Austin AI/ML postgraduate program, with links to the e-portfolio and certificate. */
const EPortfolioCard: React.FC = () => (
  <Card className="eportfolio">
    <span className="eportfolio__icon">
      <Icon icon={GraduationCap} size={28} />
    </span>
    <div className="eportfolio__body">
      <h3 className="eportfolio__title">Postgraduate Program in AI &amp; Machine Learning</h3>
      <p className="eportfolio__subtitle">The University of Texas at Austin · Business Applications</p>
      <p className="eportfolio__text">
        Coursework and applied AI/ML projects from the program, collected in my academic e-portfolio.
      </p>
      <div className="eportfolio__actions">
        <Button href={profileData.basicInfo.ePortfolio} size="sm" icon={<Icon icon={BookOpen} size={16} />}>
          View e-portfolio
        </Button>
        <Button href={UT_AUSTIN_CERTIFICATE_URL} size="sm" variant="secondary" icon={<Icon icon={Award} size={16} />}>
          View certificate
        </Button>
      </div>
    </div>
  </Card>
);

export default EPortfolioCard;
